import React from "react"
import Img from "gatsby-image"

import "./Portrait.scss"

const Portrait = ({ fixed }) => <Img className="Portrait" fixed={fixed} />

export default Portrait
